import {
  ComplexLossDataResponse,
  ApiResponseWithPaging,
  ComplexLossFiltersRequest,
} from '@dispatch/shared/types';
import { dispatchClient } from '../clients';
import invariant from 'tiny-invariant';
import { mapResponseWithPaging } from '../helpers/AxiosMappers';

const APIM_SERVICE_COMPLEX_LOSSES_URL = 'dispatch/service/Tasks/complex-loss';

export async function getComplexLossDataPaginated(
  filters: ComplexLossFiltersRequest,
  continuationToken?: string
): Promise<ApiResponseWithPaging<any>> {
  invariant(
    filters.startDate || filters.endDate,
    'Missing request data, cannot fetch complex children data'
  );

  const response = await dispatchClient.post<ComplexLossDataResponse>(
    `${APIM_SERVICE_COMPLEX_LOSSES_URL}`,
    filters,
    {
      params: {
        pageSize: filters.pageSize,
      },
      headers: {
        'Continuation-Token': continuationToken || '',
      },
    }
  );

  const mappedResponse =
    mapResponseWithPaging<ComplexLossDataResponse>(response);

  return {
    ...mappedResponse,
    data: mappedResponse.data || {},
  };
}
